import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-add",
  "use": "icon-icon-add-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-add\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-add .cls-1 {\r\n        fill: #459fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-add_路径_185\" data-name=\"路径 185\" class=\"cls-1\" d=\"M70,65a6,6,0,1,0,6,6A6,6,0,0,0,70,65Zm0,10.982A4.982,4.982,0,1,1,74.982,71,4.983,4.983,0,0,1,70,75.982Z\" transform=\"translate(-64 -65)\" />\r\n  <path id=\"icon-icon-add_联合_136\" data-name=\"联合 136\" class=\"cls-1\" d=\"M-3256.5-3902.5v-2h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2h2a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-2v2a.5.5,0,0,1-.5.5A.5.5,0,0,1-3256.5-3902.5Z\" transform=\"translate(3262 3911)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-add.svg
// module id = vUdU
// module chunks = 3